module.exports = __webpack_public_path__ + "static/media/computer_tracking_img.9b875bbf.jpg";